const isValidUrl = urlString => {
  var urlPattern = new RegExp(
    "^(https?:\\/\\/)?" + // validate protocol
    "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
    "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
    "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
    "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ) // validate fragment locator
  return !!urlPattern.test(urlString)
}

const getRedirectURL = (url, siteURL) => {
  let redirectUrl

  if (isValidUrl(url)) {
    // URL is an external URL
    redirectUrl = !url.includes("http") ? `http://${url}` : url
  } else {
    //URL is an page slug
    redirectUrl = `${siteURL}${url}`
  }
  return redirectUrl
}

const getSectionFieldName = sec => {
  const postFix = "Section"
  let sectionName

  if (sec.section) {
    sectionName = sec.section
  } else {
    const sectionAtomName = sec.__typename.split("_")
    const startingIndex = sectionAtomName.indexOf("SECTIONS")
    const sectionPrefixArray = sectionAtomName.slice(startingIndex + 1)

    if (sectionPrefixArray.length === 1) {
      sectionName = sectionPrefixArray[0] + postFix
    } else {
      sectionName = sectionPrefixArray.join("") + postFix
    }
  }
  return sectionName
}

const normalizeSections = sections => {
  return sections?.map(section => {
    if (!section.section) {
      // adding section.section field instead of custom name to make it easier to reference that field for all sections
      let updatedSection
      let sectionName = getSectionFieldName(section)
      updatedSection = { ...section, section: section[sectionName] }
      return updatedSection
    }
    return section
  })
}

const normalize = data => {
  const isObject = data =>
    Object.prototype.toString.call(data) === "[object Object]"
  const isArray = data =>
    Object.prototype.toString.call(data) === "[object Array]"

  const flatten = data => {
    if (!data.attributes) return data

    return {
      id: data.id,
      ...data.attributes,
    }
  }

  if (isArray(data)) {
    return data.map(item => normalize(item))
  }

  if (isObject(data)) {
    if (isArray(data.data)) {
      data = [...data.data]
    } else if (isObject(data.data)) {
      data = flatten({ ...data.data })
    } else if (data.data === null) {
      data = null
    } else {
      data = flatten(data)
    }

    for (const key in data) {
      data[key] = normalize(data[key])
    }

    return data
  }

  return data
}

const fixTypeDefName = name => {
  name = name.replace("RelationResponseCollection", "s")
  name = name.replace("EntityResponseCollection", "s")
  name = name.replace("EntityResponse", "")
  name = name.replace("Entity", "")

  return name
}

const fixTypeRefName = typeDef => {
  if (
    typeDef.name != null &&
    typeDef.name.endsWith("EntityResponseCollection")
  ) {
    typeDef.ofType = {
      kind: "NON_NULL",
      name: null,
      ofType: {
        kind: "OBJECT",
        name: typeDef.name.replace("EntityResponseCollection", ""),
        ofType: null,
      },
    }
    typeDef.kind = "LIST"
    typeDef.name = null

    return typeDef
  }

  if (typeDef.ofType != null) {
    typeDef.ofType = fixTypeRefName(typeDef.ofType)
  }

  if (typeDef.name != null) {
    typeDef.name = fixTypeDefName(typeDef.name)
  }

  return typeDef
}

const fixTypeDef = typeDef => {
  const fixedType = {
    ...typeDef,
    name: fixTypeDefName(typeDef.name),
  }

  fixedType.fields = typeDef.fields.map(y => ({
    ...y,
    type: {
      ...fixTypeRefName(y.type),
    },
  }))

  return fixedType
}

module.exports = {
  isValidUrl,
  getRedirectURL,
  normalize,
  getSectionFieldName,
  normalizeSections,
}
